/**
 * Page wrapper for the New-monitor wizard route (/v4/monitor/new).
 *
 * Mounted under <AdminRoute require="firm">, which also admits a legacy
 * role==='admin' with no RBAC caps. This component refines that to exactly what
 * creating a monitor needs end-to-end: POST /import-jobs is gated on
 * (FIRM_MANAGE || PLATFORM_MANAGE) at the router AND MONITORING_CONTRIBUTE on
 * create, so a user who lacks the composite would reach the wizard and 403 on
 * Save. Mirrors the "New monitor" button gate. AdminRoute has already waited for
 * capabilities to load before rendering us, so `can(...)` is reliable here.
 */
import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { useAccess, Capability } from '../../../hooks/useAccess';
import MonitorSetupWizard from './wizard/MonitorSetupWizard';

const MonitorSetupPage: React.FC = () => {
  const navigate = useNavigate();
  const { can } = useAccess();

  const canSetUpMonitor =
    can(Capability.MonitoringContribute)
    && (can(Capability.FirmManage) || can(Capability.PlatformManage));

  if (!canSetUpMonitor) {
    return <Navigate to="/v4/records" replace />;
  }

  return <MonitorSetupWizard onExit={() => navigate('/v4/records')} />;
};

export default MonitorSetupPage;
